import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import * as DE from '@nll/datum/lib/DatumEither';
import { constant, identity, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
export var altSuccess = function altSuccess(b) {
  return function (a) {
    return DE.isSuccess(a) ? a : b();
  };
};
export var squashRefresh = function squashRefresh(onInitial, onLoading, onRepleteError, onRepleteSuccess) {
  return DE.fold(onInitial, onLoading, onLoading, onLoading, onRepleteError, onRepleteSuccess);
};

var let_ = function let_(name, f) {
  return DE.map(function (a) {
    return Object.assign({}, a, _defineProperty({}, name, f(a)));
  });
};

export { let_ as let };
export var bindW = function bindW(name, f) {
  return function (ma) {
    return pipe(ma, DE.chain(function (a) {
      return pipe(f(a), DE.map(function (b) {
        return Object.assign({}, a, _defineProperty({}, name, b));
      }));
    }));
  };
};
export var getSuccessOrElse = function getSuccessOrElse(alt) {
  var altFn = constant(alt);
  return function (de) {
    return pipe(de, DE.refreshFold(altFn, altFn, altFn, identity));
  };
};
export var chainW = function chainW(f) {
  return function (ma) {
    return pipe(ma, DE.chain(f));
  };
};
export var successToOption = DE.squash(constant(O.none), constant(O.none), O.some);
export var zip = function zip(second) {
  return function (first) {
    return pipe(first, DE.map(function (f) {
      return function (s) {
        return [f, s];
      };
    }), DE.ap(second));
  };
};